<!--
 * @description: 左边图片 右边文字排列
 * @Author: Jay
 * @Date: 2021-09-24 11:37:35
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-11 16:31:13
-->
<template>
  <div>
    <div class="with-code flex box-shadow">
      <!-- 大图 -->
      <div v-class="'animate__animated animate__fadeInUp'">
        <el-image
          class="with-img"
          :src="$api + pictureData.image"
          fit="fit"
        />
      </div>
      <!-- 左边内容 -->
      <div v-class="'animate__animated animate__fadeInUp'">
        <div class="padding-sm text-align">
          <h3 class="font_size_xxl text-black">{{pictureData.name}}</h3>
          <h1 class="padding-top-sm font_size_xl text-gray">{{pictureData.title}}</h1>
          <!-- 内容介绍 -->
          <div class="margin-top font_size_df txt-detail">
            <p v-html="pictureData.content"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "leftPicture",
  props: ["pictureData"],
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.with-code {
  border-radius: 5px;
  height: 440px;
  //图片
  .with-img {
    width: 670px;
    height: 100%;
    border-radius: 5px 0 0 5px;
  }

  //   内容介绍
  .txt-detail {
    width: 498px;
    color: #666666;
    line-height: 32px;
    display: -webkit-box;
    display: -moz-box;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
  }
}
</style>